export default __webpack_public_path__ + "static/media/reindex.f575d4fa.svg";